import {
  Button,
  Col,
  Modal,
  Row,
  Table,
  Tabs,
  Form as FormAntd,
  Tree,
} from "antd";
import { Lock, PencilDash, PlusIcon } from "../../assets/icon";
import {
  applyFilters,
  buildColumnsWithHeaderFilters,
  Form,
  HeaderTable,
  Input,
  PermissionDirect,
  Select,
} from "../../Components";
import styles from "./Setting.module.scss";
import { TabsProps } from "antd/lib";
import { useEffect, useMemo, useRef, useState } from "react";
import dayjs from "dayjs";
import {
  getPermissionFeatures,
  getPermissionRegions,
  UserApi,
  GroupApi,
} from "../../services";
import { useHistory, useLocation } from "react-router";
import { useRecoilValue } from "recoil";
import { UserAtom } from "../../store";
import { checkPermissions } from "../../utils/checkPermissions";
import { handleError } from "../../utils/errorHandler";
import { getPermissionDirections } from "../../services/domains/permission";
import { useRequestLock } from "../../shared/hooks/useRequestLock";
import { sanitizeGroupFeaturePermissions } from "./helpers";
const { confirm } = Modal;
const Setting = () => {
  // Define constant
  const history = useHistory();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const tabs = query.get("tabs");
  const permissionState = useRecoilValue<any>(UserAtom.permissions);
  const features = permissionState?.features;
  const [loading, setLoading] = useState(false);
  const canViewUsers = checkPermissions("USERS", "view", features);
  const canAddUser =
    canViewUsers && checkPermissions("USERS", "add", features);
  const canEditUser =
    canViewUsers && checkPermissions("USERS", "edit", features);
  const canDeleteUser =
    canViewUsers && checkPermissions("USERS", "delete", features);
  const canViewUserGroups = checkPermissions("USER_GROUPS", "view", features);
  const canAddUserGroup =
    canViewUserGroups && checkPermissions("USER_GROUPS", "add", features);
  const canEditUserGroup =
    canViewUserGroups && checkPermissions("USER_GROUPS", "edit", features);
  const userPermissionsRef = useRef({
    view: canViewUsers,
    add: canAddUser,
    edit: canEditUser,
    delete: canDeleteUser,
  });
  const userGroupPermissionsRef = useRef({
    view: canViewUserGroups,
    add: canAddUserGroup,
    edit: canEditUserGroup,
  });
  userPermissionsRef.current = {
    view: canViewUsers,
    add: canAddUser,
    edit: canEditUser,
    delete: canDeleteUser,
  };
  userGroupPermissionsRef.current = {
    view: canViewUserGroups,
    add: canAddUserGroup,
    edit: canEditUserGroup,
  };
  const defaultActiveTab = tabs === "3" ? "3" : "1";
  const typeUser = [
    { label: "Quản trị viên", value: "ADMIN" },
    { label: "Ban lãnh đạo", value: "MANAGER" },
    { label: "Kế toán", value: "ACCOUNTANT" },
    { label: "Vận hành", value: "OPERATOR" },
    { label: "Nhà thầu", value: "TRUCK_VENDOR" },
    { label: "Lái xe", value: "DRIVER" },
    { label: "Forwarder", value: "FORWARDER" },
  ];
  const typeGroup = [
    { label: "Quản lý", value: "MANAGER" },
    { label: "Vận hành", value: "OPERATOR" },
    { label: "Sale", value: "SALE" },
  ];
  const [groupFormInstance] = FormAntd.useForm();
  const [userFormInstance] = FormAntd.useForm();
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Người dùng",
      disabled: !canViewUsers,
    },
    {
      key: "3",
      disabled: !canViewUserGroups,
      label: "Nhóm người dùng",
    },
  ];
  const canViewTab = (tabKey: string) => {
    if (tabKey === "1") return canViewUsers;
    if (tabKey === "3") return canViewUserGroups;
    return false;
  };
  const getFirstAllowedTab = () => {
    if (canViewUsers) return "1";
    if (canViewUserGroups) return "3";
    return "1";
  };
  const columnsUser = useMemo<any[]>(
    () => [
      { title: "ID", dataIndex: "_id", fixed: false, hidden: true },
      {
        title: "Họ và Tên",
        dataIndex: "name",
        fixed: false,
        hidden: false,
        filterConfig: {
          type: "string",
          filterProps: {
            placeholder: "Nhập tên người dùng",
          },
        },
      },
      {
        title: "Tên hiển thị",
        dataIndex: "accountName",
        fixed: false,
        hidden: false,
        filterConfig: {
          type: "string",
          filterProps: {
            placeholder: "Nhập tên hiển thị",
          },
        },
      },
      {
        title: "Email",
        dataIndex: "email",
        fixed: false,
        hidden: false,
        filterConfig: {
          type: "string",
          filterProps: {
            placeholder: "Nhập email",
          },
        },
      },
      {
        title: "SĐT",
        dataIndex: "phoneNumber",
        fixed: false,
        hidden: false,
      },
      // {
      //   title: "Loại tài khoản",
      //   dataIndex: "accountType",
      //   fixed: false,
      //   hidden: false,
      //   filterConfig: {
      //     type: "string",
      //     filterProps: {
      //       placeholder: "Nhập loại tài khoản",
      //     },
      //   },
      // },
      // {
      //   title: "Phòng ban",
      //   dataIndex: "department",
      //   fixed: false,
      //   hidden: false,
      //   filterConfig: {
      //     type: "string",
      //     filterProps: {
      //       placeholder: "Nhập phòng ban",
      //     },
      //   },
      // },
      {
        title: "Lần hoạt động cuối",
        dataIndex: "lastActiveAt",
        fixed: false,
        hidden: false,
        filterConfig: {
          type: "dateRange",
        },
        render: (row: any) => dayjs(row).format("HH:MM:ss YYYY/MM/DD"),
      },
      {
        title: "Trạng thái",
        dataIndex: "status",
        fixed: false,
        hidden: false,
        render: (row: string) => (
          <div
            style={{
              color: row === "ACTIVE" ? "#00B69B" : "#F63535",
              fontWeight: "bold",
            }}
            title={row === "ACTIVE" ? "Đang hoạt động" : "Bị khoá"}
          >
            {row === "ACTIVE" ? "Đang hoạt động" : "Bị khoá"}
          </div>
        ),
        filterConfig: {
          type: "select",
          filterProps: {
            placeholder: "Chọn trạng thái",
            options: [
              { label: "Đang hoạt động", value: "ACTIVE" },
              { label: "Bị khoá", value: "LOCKED" },
            ],
          },
        },
      },
      {
        title: "Tác vụ",
        dataIndex: "actions",
        fixed: false,
        hidden: false,
        render: (row: string, record: any) => (
          <div>
            <Button
              icon={<PencilDash />}
              style={{ margin: "0 5px" }}
              disabled={!canEditUser}
              title="Chỉnh sửa"
              onClick={() => {
                if (!userPermissionsRef.current.edit) return;
                setOnOpenModalEditUser(record);
                userFormInstance.resetFields();
                userFormInstance.setFieldsValue({
                  ...record,
                  lastActiveAt: dayjs(record.lastActiveAt).format(
                    "HH:MM:ss YYYY/MM/DD",
                  ),
                });
              }}
            />
            <Button
              icon={<Lock />}
              style={{
                margin: "0 5px",
                color: record.status === "LOCKED" ? "#0082FB" : "#F63535",
              }}
              title={record.status === "LOCKED" ? "Mở khoá" : "Khoá"}
              disabled={!canEditUser}
              onClick={() =>
                handleActionLockUser(
                  record._id,
                  record.status === "ACTIVE" ? "LOCKED" : "ACTIVE",
                  record,
                )
              }
            />
          </div>
        ),
      },
    ],
    [canEditUser, userFormInstance],
  );
  const columnsRole = [
    { title: "ID", dataIndex: "_id", fixed: false, hidden: true },
    {
      title: "Nhóm người dùng",
      dataIndex: "name",
      fixed: false,
      hidden: false,
    },
    // {
    //   title: "Code",
    //   dataIndex: "code",
    //   fixed: false,
    //   hidden: false,
    // },
    {
      title: "Số lượng quyền",
      dataIndex: "countFeatures",
      fixed: false,
      hidden: false,
    },
    {
      title: "Số lượng người dùng",
      dataIndex: "countUser",
      fixed: false,
      hidden: false,
    },
    {
      title: "Mô tả",
      dataIndex: "description",
      fixed: false,
      hidden: false,
    },
    {
      title: "Trạng thái",
      dataIndex: "state",
      fixed: false,
      hidden: false,
      render: (row: string) => (
        <div
          style={{
            color: row === "ACTIVE" ? "#00B69B" : "#F63535",
            fontWeight: "bold",
          }}
          title={row === "ACTIVE" ? "Đang hoạt động" : "Ngừng hoạt động"}
        >
          {row === "ACTIVE" ? "Đang hoạt động" : "Ngừng hoạt động"}
        </div>
      ),
    },
    {
      title: "Tác vụ",
      dataIndex: "actions",
      fixed: false,
      hidden: false,
      render: (row: string, record: any) => (
        <div>
          <Button
            icon={<PencilDash />}
            style={{ margin: "0 5px" }}
            title="Chỉnh sửa"
            disabled={!canEditUserGroup}
            onClick={() => {
              handleOnUpdateGroupDetail(record._id);
            }}
          />
        </div>
      ),
    },
  ];
  const rawNewUser = {
    id: "",
    name: "",
    email: "",
    accountType: "",
    department: "",
    lastActiveAt: "",
    status: "",
  };
  const [filters, setFilters] = useState<any>({});
  const [listRegionAndFeatures, setListRegionandFeatures] = useState<any>({
    regions: [],
    features: [],
  });
  const [dataUsers, setDataUsers] = useState<any>([]);
  const [dataListUserGroup, setDataListUserGroup] = useState<any>([]);
  const [activeTabs, setActiveTabs] = useState(defaultActiveTab);
  const [onOpenModal, setOnOpenModal] = useState<string>();
  const [onOpenModalEditUser, setOnOpenModalEditUser] = useState<any>();
  const [activeTabPermissions, setActiveTabPermissions] = useState("1");
  const [listUserCreate, setListUserCreate] = useState<any>([]);
  const [listGroupActive, setListGroupActive] = useState<any>({
    regions: [],
    features: [],
    users: [],
    directions: [],
  });
  const [onEditGroup, setOnEditGroup] = useState(false);
  const { isLocked, runLocked } = useRequestLock();
  const userSaveKey = `setting:user:${onOpenModalEditUser?._id ?? "new"}`;
  const groupSaveKey = `setting:group:${listGroupActive._id ?? "new"}`;
  const isUserSaving = isLocked(userSaveKey);
  const isGroupSaving = isLocked(groupSaveKey);
  const canModifyGroupModal = listGroupActive._id
    ? canEditUserGroup
    : canAddUserGroup;
  const configInput: any = {
    // valuesFormOnChange: (value: any) => {
    // setFormValue({ ...formValue, ...value });
    // },
    dataSource: {
      table: `posts`,
      update: {
        // where: update,
        isBackendData: false,
        // data: formValue ? formValue : undefined,
      },
    },
    fields: [
      {
        displayType: "Group",
        dataIndex: "group1",
        col: { span: 24 },
        divider: true,
        className: [styles.FormItem].join(" "),
        fields: [
          {
            label: "Tên nhóm", // show label
            dataIndex: "name", // key
            displayType: "Input", // type input
            col: { span: 8 },
            rules: [
              {
                required: true,
                message: "Không được để trống phần này",
              },
            ],
            input: {},
          },
          {
            label: "Loại người dùng", // show label
            dataIndex: "profileCode", // key
            displayType: "Select", // type input
            col: { span: 8 },
            rules: [
              {
                required: true,
                message: "Không được để trống phần này",
              },
            ],
            input: {
              options: typeGroup,
            },
          },
          // {
          //   label: "Mã", // show label
          //   dataIndex: "code", // key
          //   displayType: "Input", // type input
          //   col: { span: 8 },
          //   rules: [
          //     {
          //       required: true,
          //       message: "Không được để trống phần này",
          //     },
          //   ],
          //   input: {},
          // },
          {
            label: "Trạng thái", // show label
            dataIndex: "state", // key
            displayType: "Select", // type input
            col: { span: 8 },
            input: {
              options: [
                { label: "Đang hoạt động", value: "ACTIVE" },
                { label: "Ngừng hoạt động", value: "INACTIVE" },
              ],
            },
          },
          {
            label: "Mô tả", // show label
            dataIndex: "description", // key
            displayType: "TextArea", // type input
            col: { span: 24 },
            input: {},
          },
        ],
      },
    ],
  };
  const configInputEditUser: any = {
    // valuesFormOnChange: (value: any) => {
    // setFormValue({ ...formValue, ...value });
    // },
    dataSource: {
      table: `users`,
      update: {
        // where: update,
        isBackendData: false,
        // data: formValue ? formValue : undefined,
      },
    },
    fields: [
      {
        displayType: "Group",
        dataIndex: "group1",
        col: { span: 24 },
        divider: true,
        className: [styles.FormItem].join(" "),
        fields: [
          {
            label: "Họ và Tên", // show label
            dataIndex: "name", // key
            displayType: "Input", // type input
            col: { span: 12 },
            rules: [
              {
                required: true,
                message: "Không được để trống phần này",
              },
            ],
            input: {},
          },
          {
            label: "Tên hiển thị", // show label
            dataIndex: "accountName", // key
            displayType: "Input", // type input
            col: { span: 12 },
            rules: [
              {
                required: true,
                message: "Không được để trống phần này",
              },
            ],
            input: {},
          },
          {
            label: "Loại", // show label
            dataIndex: "type", // key
            displayType: "Select", // type input
            col: { span: 12 },
            rules: [
              {
                required: true,
                message: "Không được để trống phần này",
              },
            ],
            input: {
              //'ADMIN', 'MANAGER', 'ACCOUNTANT', 'FORWARDER', 'TRUCK_VENDOR', 'DRIVER', 'OPERATOR'
              options: typeUser,
            },
          },
          {
            label: "Trạng thái", // show label
            dataIndex: "status", // key
            displayType: "Select", // type input
            col: { span: 12 },
            input: {
              options: [
                { label: "Đang hoạt động", value: "ACTIVE" },
                { label: "Bị khoá", value: "LOCKED" },
              ],
            },
          },
          {
            label: "Email", // show label
            dataIndex: "email", // key
            displayType: "Input", // type input
            col: { span: 12 },
            rules: [
              {
                required: true,
                message: "Không được để trống phần này",
              },
            ],
            input: {
              placeholder: "Nhập email",
              type: "email",
            },
          },
          {
            label: "Mật khẩu", // show label
            dataIndex: "password", // key
            displayType: "InputPassword", // type input
            col: { span: 12 },
            input: {
              placeholder: "Nhập mật khẩu",
              visibilityToggle: true,
            },
          },
          {
            label: "Số điện thoại", // show label
            dataIndex: "phoneNumber", // key
            displayType: "Input", // type input
            col: { span: 12 },
            rules: [
              {
                required: true,
                message: "Không được để trống phần này",
              },
              {
                pattern: /^(0|\+84)(3|5|7|8|9)[0-9]{8}$/,
                message: "Số điện thoại không hợp lệ",
              },
            ],
            input: {
              placeholder: "Nhập số điện thoại",
              type: "tel",
              maxLength: 10,
              onChange: (v: string) => {},
            },
          },
          {
            label: "Ghi chú", // show label
            dataIndex: "note", // key
            displayType: "Input", // type input
            col: { span: 12 },
            input: {
              placeholder: "Nhập ghi chú",
            },
          },
          // {
          //   label: "Bộ phận", // show label
          //   dataIndex: "department", // key
          //   displayType: "Input", // type input
          //   col: { span: 24 },
          //   input: {
          //     placeholder: "Vị trí làm việc",
          //     disabled: true,
          //   },
          //   rules: [],
          // },
          {
            label: "Lần hoạt động cuối", // show label
            dataIndex: "lastActiveAt", // key
            displayType: "Input", // type input
            col: { span: 24 },
            input: {
              placeholder: "Lần hoạt động cuối",
              disabled: true,
            },
          },
        ],
      },
    ],
  };
  // Function to create
  const canViewSettingLive = () =>
    userPermissionsRef.current.view ||
    userGroupPermissionsRef.current.view;
  const canViewTabLive = (tabKey: string) => {
    if (tabKey === "1") return userPermissionsRef.current.view;
    if (tabKey === "3") return userGroupPermissionsRef.current.view;
    return false;
  };
  const getListRegionsAndFeatures = async () => {
    if (!canViewSettingLive()) return;
    const permissionRegions: any = await getPermissionRegions({});
    if (!canViewSettingLive()) return;
    const permissionFeatures: any = await getPermissionFeatures({});
    if (!canViewSettingLive()) return;
    const permissionDirections: any = await getPermissionDirections({});
    if (!canViewSettingLive()) return;
    setListRegionandFeatures({
      regions: permissionRegions,
      features: permissionFeatures,
      directions: permissionDirections,
    });
  };
  const fetchUsers = async () => {
    if (!canViewSettingLive()) return;
    const res = await UserApi.getAllUsers({});
    if (!canViewSettingLive()) return;
    setDataUsers(res?.data || []);
  };
  const fetchGroups = async () => {
    if (!userGroupPermissionsRef.current.view) return;
    const res = await GroupApi.getListUserGroup({});
    if (!userGroupPermissionsRef.current.view) return;
    setDataListUserGroup(res?.data || []);
  };
  const loadDataByTab = async (tabKey: string) => {
    if (!canViewTabLive(tabKey)) return;
    setLoading(true);
    try {
      switch (tabKey) {
        case "1":
          await fetchUsers();
          break;
        case "3":
          await Promise.all([fetchGroups(), fetchUsers()]);
          break;
        default:
          break;
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  const dataSource = useMemo(() => {
    return applyFilters(dataUsers, filters, columnsUser);
  }, [filters, dataUsers]);
  // Function to handle action
  const handleActionDeleteUser = async (id: string) => {
    if (!userPermissionsRef.current.delete) return;
    try {
      await UserApi.deleteUser(id);
      await fetchUsers();
      setOnOpenModalEditUser(undefined);
      userFormInstance.resetFields();
    } catch (error) {
      handleError(error);
    }
  };
  const handleActionLockUser = async (
    _id: string,
    status: string,
    record: any,
  ) => {
    if (!userPermissionsRef.current.edit) return;
    try {
      const response = await UserApi.putUpdateUser(
        { ...record, status: status },
        _id,
      );
      if (!userPermissionsRef.current.edit) return;
      if (response) {
        setOnOpenModalEditUser((prev: any) =>
          prev
            ? { ...prev, ...response, status: response.status || status }
            : prev,
        );
        await fetchUsers();
      }
    } catch (error) {
      handleError(error);
    }
  };
  const closeUserModal = () => {
    setOnOpenModalEditUser(undefined);
    userFormInstance.resetFields();
  };
  const handleActionCancelUser = () => {
    if (isLocked(userSaveKey)) return;
    closeUserModal();
  };
  const handleActionSaveUser = async () => {
    await runLocked(userSaveKey, async () => {
      try {
        await userFormInstance.validateFields();
        const values = userFormInstance.getFieldsValue();
        if (onOpenModalEditUser?._id) {
          if (!userPermissionsRef.current.edit) return;
          const res = await UserApi.putUpdateUser(
            values,
            onOpenModalEditUser._id,
          );
          if (!userPermissionsRef.current.edit) return;
          if (res) {
            await fetchUsers();
            closeUserModal();
          }
        } else {
          if (!userPermissionsRef.current.add) return;
          const res = await UserApi.postCreateUser(values);
          if (!userPermissionsRef.current.add) return;
          if (res) {
            await fetchUsers();
            closeUserModal();
          }
        }
      } catch (error) {
        handleError(error);
      }
    });
  };
  const handleOnUpdateGroupDetail = async (id: string) => {
    if (!userGroupPermissionsRef.current.edit) return;
    try {
      const [res] = await Promise.all([
        GroupApi.getDetailGroup({}, id),
        fetchUsers(),
      ]);
      if (!userGroupPermissionsRef.current.edit) return;
      const data = res?.data;
      setOnOpenModal("3");
      setListGroupActive({
        regions: data.regionList || [],
        features: data.featureList || [],
        users: data.userList || [],
        directions: data.directionList || [],
        _id: data._id,
      });
      setListUserCreate([]);
      setOnEditGroup(false);
      groupFormInstance.resetFields();
      groupFormInstance.setFieldsValue({
        _id: data._id,
        name: data.name,
        state: data.state,
        description: data.description,
        profileCode: data?.orderCostSheet?.profileCode,
      });
    } catch (error) {
      handleError(error);
    }
  };
  const openCreateGroupModal = async () => {
    if (!userGroupPermissionsRef.current.add) return;
    try {
      await fetchUsers();
      if (!userGroupPermissionsRef.current.add) return;
      setOnOpenModal("3");
      setListGroupActive({
        regions: [],
        features: [],
        users: [],
        _id: undefined,
      });
      setListUserCreate([]);
      setOnEditGroup(false);
      groupFormInstance.resetFields();
      groupFormInstance.setFieldsValue({
        state: "ACTIVE",
      });
    } catch (error) {
      handleError(error);
    }
  };
  const openCreateUserModal = () => {
    if (!userPermissionsRef.current.add) return;
    setOnOpenModalEditUser(rawNewUser);
    userFormInstance.resetFields();
    userFormInstance.setFieldsValue(rawNewUser);
  };
  const closeGroupModal = () => {
    setOnOpenModal(undefined);
    setListGroupActive({
      regions: [],
      features: [],
      users: [],
      _id: undefined,
    });
    setListUserCreate([]);
    groupFormInstance.resetFields();
    setOnEditGroup(false);
  };
  const handleCancelGroup = () => {
    if (isLocked(groupSaveKey)) return;
    closeGroupModal();
  };
  const handleSaveGroup = async () => {
    await runLocked(groupSaveKey, async () => {
      try {
        await groupFormInstance.validateFields();
        const formValues = groupFormInstance.getFieldsValue();
        let targetGroupId = listGroupActive._id;
        const isEditingGroup = Boolean(targetGroupId);
        const canSaveGroupLive = () =>
          isEditingGroup
            ? userGroupPermissionsRef.current.edit
            : userGroupPermissionsRef.current.add;
        const pendingUsers = listUserCreate.filter((user: any) => user);

        if (pendingUsers.some((user: any) => !user?._id)) {
          throw new Error("Vui lòng chọn đầy đủ người dùng trước khi lưu nhóm");
        }

        const validUsers = pendingUsers.filter((user: any) => user?._id);

        if (targetGroupId) {
          if (!canSaveGroupLive()) return;
          await GroupApi.putUpdateGroup(formValues, targetGroupId);
        } else {
          if (!canSaveGroupLive()) return;
          const response: any = await GroupApi.postCreateGroup(formValues);
          targetGroupId = response?._id;
        }

        if (!canSaveGroupLive()) return;
        const listUser = [...validUsers, ...listGroupActive.users];
        const respone = await GroupApi.putUpdateGroupAssign(
          {
            userIds: listUser.map((user: any) => user._id),
            regions: listGroupActive.regions,
            permissions: sanitizeGroupFeaturePermissions(
              listGroupActive.features,
              listRegionAndFeatures.features,
            ),
            directions: listGroupActive.directions,
          },
          targetGroupId,
        );

        if (!canSaveGroupLive()) return;
        if (respone) {
          await fetchGroups();
          closeGroupModal();
        }
      } catch (error) {
        handleError(error);
      }
    });
  };
  // Function to render
  const renderListPermission = (
    permissions: any,
    type: "region" | "feature" | "direction",
  ) => {
    const checkedKeys =
      type === "region"
        ? listGroupActive.regions
        : type === "feature"
          ? listGroupActive.features
          : listGroupActive.directions;
    return (
      <div className={styles.ListPermissions}>
        <div className={styles.WarpListPermissions}>
          <Tree
            checkable
            selectable={false}
            disabled={!canModifyGroupModal}
            treeData={permissions}
            onCheck={(checkedKeys: any) => {
              if (!canModifyGroupModal) return;
              if (type === "region") {
                setListGroupActive((prev: any) => ({
                  ...prev,
                  regions: checkedKeys,
                }));
              }
              if (type === "feature") {
                setListGroupActive((prev: any) => ({
                  ...prev,
                  features: checkedKeys,
                }));
              } else {
                setListGroupActive((prev: any) => ({
                  ...prev,
                  directions: checkedKeys,
                }));
              }
              setOnEditGroup(true);
            }}
            checkedKeys={checkedKeys}
            defaultExpandAll
          />
        </div>
      </div>
    );
  };
  const renderColumns = buildColumnsWithHeaderFilters(
    columnsUser,
    filters,
    setFilters,
  );
  // Tabs permission: listUserCreate, listUserActive
  const tabPermission = [
    {
      key: "1",
      label: "Danh sách người dùng",
      children: (
        <div className={styles.FormInput}>
          <Form form={groupFormInstance} {...configInput} />
          <div className={styles.ListUser}>
            <div className={styles.WarpListUser}>
              {listUserCreate &&
                listUserCreate.length > 0 &&
                listUserCreate.map((user: any, index: number) => {
                  return (
                    <Row className={styles.WarpUser} align="middle" key={index}>
                      <Col span={14}>
                        <Row align="middle">
                          <div className={styles.WarpImage}>
                            <img src="/images/user.png" />
                          </div>
                          <div style={{ width: "70%" }}>
                            <Select
                              value={user?._id}
                              options={dataUsers
                                .filter(
                                  (us: any) =>
                                    !listUserCreate.find(
                                      (u: any) => u._id === us._id,
                                    ) &&
                                    !listGroupActive.users.find(
                                      (u: any) => u._id === us._id,
                                    ),
                                )
                                .map((us: any) => ({
                                  label: `${us.name} / ${us.email}`,
                                  value: us._id,
                                }))}
                              showSearch
                              optionFilterProp="label"
                              onChange={(ie) => {
                                const newUser = dataUsers.find(
                                  (us: any) => us._id === ie,
                                );
                                const newListUserCreate = [...listUserCreate];
                                newListUserCreate[index] = newUser;
                                setListUserCreate(newListUserCreate);
                                setOnEditGroup(true);
                              }}
                              style={{ width: "100%" }}
                            />
                          </div>
                        </Row>
                      </Col>
                      <Col span={5}>
                        <Input disabled value={user?.department} />
                      </Col>
                      <Col span={5}>
                        <Row justify="center">
                          <div
                            onClick={() => {
                              if (!canModifyGroupModal) return;
                              const newListUserCreate = [...listUserCreate];
                              newListUserCreate.splice(index, 1);
                              setListUserCreate(newListUserCreate);
                              setOnEditGroup(true);
                            }}
                          >
                            Xoá
                          </div>
                        </Row>
                      </Col>
                    </Row>
                  );
                })}
              {listGroupActive.users &&
                listGroupActive.users.length > 0 &&
                listGroupActive.users.map((user: any, index: number) => {
                  return (
                    <Row className={styles.WarpUser} align="middle" key={index}>
                      <Col span={14}>
                        <Row align="middle">
                          <div className={styles.WarpImage}>
                            <img src="/images/user.png" />
                          </div>
                          <div>
                            {user.name} / {user.email}
                          </div>
                        </Row>
                      </Col>
                      <Col span={5}>{user.department}</Col>
                      <Col span={5}>
                        <Row justify="center">
                          <div
                            onClick={() => {
                              if (!canModifyGroupModal) return;
                              const newListUserActive = [
                                ...listGroupActive.users,
                              ];
                              newListUserActive.splice(index, 1);
                              setListGroupActive({
                                ...listGroupActive,
                                users: newListUserActive,
                              });
                              setOnEditGroup(true);
                            }}
                          >
                            Xoá
                          </div>
                        </Row>
                      </Col>
                    </Row>
                  );
                })}
            </div>
            <div>
              <Button
                color="default"
                variant="dashed"
                icon={<PlusIcon />}
                disabled={!canModifyGroupModal}
                style={{ width: "100%" }}
                onClick={() => {
                  setListUserCreate([
                    ...listUserCreate,
                    { id: "", name: "", email: "", department: "" },
                  ]);
                  setOnEditGroup(true);
                }}
              >
                Thêm mới
              </Button>
            </div>
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: "Phân quyền khu vực",
      children: renderListPermission(listRegionAndFeatures.regions, "region"),
    },
    {
      key: "3",
      label: "Phân quyền chiều hàng",
      children: renderListPermission(
        listRegionAndFeatures.directions,
        "direction",
      ),
    },
    {
      key: "4",
      label: "Phân quyền tính năng",
      children: renderListPermission(listRegionAndFeatures.features, "feature"),
    },
  ];
  const columns = () => {
    switch (activeTabs) {
      case "1":
        return renderColumns;
      case "3":
        return columnsRole;
    }
  };
  const getData = () => {
    switch (activeTabs) {
      case "1":
        return dataSource;
      case "3":
        return dataListUserGroup;
    }
  };
  const renderModalCreateRole = () => {
    return (
      <div className={styles.CreatePermissionDetail}>
        <Tabs
          activeKey={activeTabPermissions}
          items={tabPermission}
          onChange={(tab) => {
            setActiveTabPermissions(tab);
          }}
        />
      </div>
    );
  };
  const renderModalCreateGroup = () => {
    return (
      <Modal
        open={onOpenModal ? true : false}
        className={styles.Modal}
        width={"70%"}
        confirmLoading={isGroupSaving}
        closable={!isGroupSaving}
        maskClosable={!isGroupSaving}
        keyboard={!isGroupSaving}
        onCancel={() => {
          if (isLocked(groupSaveKey)) return;
          onEditGroup
            ? confirm({
                title: "Bạn có thay đổi chưa lưu",
                content: "Nếu không lưu, dữ liệu sẽ bị mất.",
                okText: "Bỏ qua",
                cancelText: "Ở lại",
                onOk: handleCancelGroup,
              })
            : handleCancelGroup();
        }}
        title={
          listGroupActive?._id
            ? "Cập nhật nhóm người dùng"
            : "Thêm mới nhóm người dùng"
        }
        onOk={() => {
          handleSaveGroup();
        }}
        okButtonProps={{ disabled: !canModifyGroupModal || isGroupSaving }}
        cancelButtonProps={{ disabled: isGroupSaving }}
        bodyProps={{
          className: styles.ModalBody,
        }}
      >
        {renderModalCreateRole()}
      </Modal>
    );
  };
  const renderModalEditUser = () => {
    return (
      <Modal
        open={onOpenModalEditUser ? true : false}
        className={styles.Modal}
        width={"70%"}
        closable={!isUserSaving}
        maskClosable={!isUserSaving}
        keyboard={!isUserSaving}
        onCancel={handleActionCancelUser}
        title={
          !onOpenModalEditUser?.id
            ? "Tạo mới người dùng"
            : "Cập nhật người dùng"
        }
        bodyProps={{
          className: styles.ModalBody,
        }}
        footer={
          <Row justify="space-between">
            <Col>
              <Button
                danger
                type="primary"
                disabled={
                  isUserSaving ||
                  !onOpenModalEditUser?._id ||
                  !canDeleteUser
                }
                onClick={() => handleActionDeleteUser(onOpenModalEditUser._id)}
              >
                Xoá người dùng
              </Button>
            </Col>
            <Col>
              <Button
                danger={onOpenModalEditUser?.status === "ACTIVE" ? true : false}
                icon={<Lock />}
                type="primary"
                style={{ marginLeft: "10px" }}
                disabled={
                  isUserSaving || !onOpenModalEditUser?._id || !canEditUser
                }
                onClick={() =>
                  handleActionLockUser(
                    onOpenModalEditUser._id,
                    onOpenModalEditUser.status === "ACTIVE"
                      ? "LOCKED"
                      : "ACTIVE",
                    onOpenModalEditUser,
                  )
                }
              >
                {onOpenModalEditUser?.status === "ACTIVE" ? "Khoá" : "Mở khoá"}
              </Button>
              <Button
                type="primary"
                style={{ marginLeft: "10px", backgroundColor: "#8E8E8E" }}
                disabled={isUserSaving}
                onClick={handleActionCancelUser}
              >
                Đóng
              </Button>
              <Button
                type="primary"
                style={{ marginLeft: "10px" }}
                loading={isUserSaving}
                disabled={
                  isUserSaving ||
                  (onOpenModalEditUser?._id ? !canEditUser : !canAddUser)
                }
                onClick={handleActionSaveUser}
              >
                {!onOpenModalEditUser?._id ? "Thêm mới" : "Cập nhật"}
              </Button>
            </Col>
          </Row>
        }
      >
        <Form form={userFormInstance} {...configInputEditUser} />
      </Modal>
    );
  };
  //Function to effect
  useEffect(() => {
    if (!canViewUsers && onOpenModalEditUser) {
      closeUserModal();
    }
  }, [canViewUsers, onOpenModalEditUser]);

  useEffect(() => {
    if (!canViewUserGroups && onOpenModal) {
      closeGroupModal();
    }
  }, [canViewUserGroups, onOpenModal]);

  useEffect(() => {
    if (!features) return;
    if (canViewTab(activeTabs)) return;

    const nextTab = getFirstAllowedTab();
    setActiveTabs(nextTab);
    history.replace(`${location.pathname}?tabs=${nextTab}`);
  }, [
    activeTabs,
    canViewUserGroups,
    canViewUsers,
    features,
    history,
    location.pathname,
  ]);

  useEffect(() => {
    if (!features || !canViewTab(activeTabs)) return;
    loadDataByTab(activeTabs);
  }, [activeTabs, canViewUserGroups, canViewUsers, features]);
  useEffect(() => {
    if (!features || (!canViewUsers && !canViewUserGroups)) return;

    getListRegionsAndFeatures();
  }, [canViewUserGroups, canViewUsers, features]);
  // Main render
  return (
    <PermissionDirect screen={["USERS", "USER_GROUPS"]}>
      <div className={styles.Setting}>
      <div className="container">
        <HeaderTable
          title="Cài đặt"
          buttons={[
            {
              children: "Thêm mới người dùng",
              icon: <PlusIcon />,
              disabled: !canAddUser,
              onClick: () => {
                openCreateUserModal();
                setActiveTabs("1");
                history.replace(`${location.pathname}?tabs=1`);
              },
              style: { backgroundColor: "#0076E3" },
            },
            {
              children: "Thêm mới nhóm người dùng",
              icon: <PlusIcon />,
              disabled: !canAddUserGroup,
              onClick: () => {
                openCreateGroupModal();
                setActiveTabs("3");
                history.replace(`${location.pathname}?tabs=3`);
              },
              style: { backgroundColor: "#0076E3" },
            },
          ]}
        />
        <Tabs
          activeKey={activeTabs}
          items={items}
          onChange={(tab) => {
            setActiveTabs(tab);
            history.replace(`${location.pathname}?tabs=${tab}`);
          }}
        />
        <Table
          size="small"
          dataSource={getData()}
          columns={columns()}
          loading={loading}
          scroll={{ x: "max-content" }}
          style={{ width: "100%" }}
          rowKey={(record: any) => String(record._id)}
        />
      </div>
      {renderModalCreateGroup()}
      {renderModalEditUser()}
      </div>
    </PermissionDirect>
  );
};
export { Setting };
